module.exports = __webpack_public_path__ + "img/icon-minus-hold.252f7c3c.svg";